/* unplugin-vue-components disabled */import { render } from "./binzhou.vue?vue&type=template&id=7c3e2fcc&scoped=true"
import script from "./binzhou.vue?vue&type=script&lang=js"
export * from "./binzhou.vue?vue&type=script&lang=js"

import "./binzhou.vue?vue&type=style&index=0&id=7c3e2fcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3e2fcc"]])

export default __exports__